import { SPRest } from "../rest";
import { Site } from "./types";
export { Site, } from "./types";
Reflect.defineProperty(SPRest.prototype, "site", {
    configurable: true,
    enumerable: true,
    get: function () {
        return Site(this._baseUrl).configure(this._options);
    },
});
//# sourceMappingURL=index.js.map